import { Button } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { useState } from "react";
import { Alert } from "../../../components/alert/Alert";

export const MissingPricesDialog = ({
  active,
  setActive,
  canDiscard,
  onDiscard,
  onDismiss,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
  canDiscard: boolean;
  onDiscard: () => void;
  onDismiss: () => void;
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="Your base price list isn't complete"
        description="It's important for your base price list to be filled in completely, so that any price list you derive from it has a base price to reference. "
      />
      <DialogContent>
        <Alert type="sellar" title="" message="" className="bg-zinc-50">
          <p>
            <b>Tip:</b> Even with a price set against it, your products aren't
            visible to customers on your storefront unless they're switched 'on'
            in the appropriate product catalogues
          </p>
        </Alert>
      </DialogContent>
      <DialogCTA>
        <Button
          color="secondary"
          loading={loading}
          onClick={() => {
            setLoading(true);
            onDismiss();
          }}
        >
          Save & Exit
        </Button>
        {canDiscard && (
          <Button
            color="red"
            loading={loading}
            onClick={() => {
              setLoading(true);
              onDiscard();
            }}
          >
            Discard
          </Button>
        )}
        <Button loading={loading} onClick={() => setActive(false)}>
          Continue editing
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
